import { object, shape } from 'prop-types';
import React from 'react';
import { RadioButtons } from '@eika/radio-button';
import { SkjemaSporsmal } from '../../ahv-schema';
import { getIsDisabled, isDisabledFatcaCrs } from '../../form-util';
import { getPreselected, isRequiredQuestion, isRequiredWhenSelected } from '../helper/component-helper';
import connect from '../helper/connect';
import text from '../../constants/text';
import { KUN_LESING } from '../../constants/general';

function RadioQuestionType({ question, context }) {
    const { definisjon, reminder = false, muligeSvar, instruks, utfyllingsregel } = question;

    const hasError = () => {
        return context.getValue(definisjon).length === 0;
    };

    const hasInvalidValue = context.hasError(definisjon);

    const isDisabled = !!(
        getIsDisabled(utfyllingsregel.regel, getPreselected(question), context.getRolle()) ||
        isDisabledFatcaCrs(question)
    );

    const getQuestionText = () => {
        // Support brittle sporsmalstekst with markup
        if (
            question.sporsmalstekst != null &&
            (question.formaterHTML || (question.config && question.config.formaterHTML))
        ) {
            /* eslint-disable react/no-danger */
            return (
                <span
                    className="skjema-input-question"
                    dangerouslySetInnerHTML={{
                        __html: question.sporsmalstekst,
                    }}
                />
            );
        }

        if (question.utfyllingsregel.regel === KUN_LESING) {
            return question.sporsmalstekst;
        }
        return isRequiredQuestion(question.utfyllingsregel) ||
            (isRequiredWhenSelected(question) && getPreselected(question))
            ? question.sporsmalstekst
            : `${question.sporsmalstekst} ${text.TEXT_OPTIONAL}`;
    };

    const options = muligeSvar.map((muligSvar) => {
        const { tekst, svarId } = muligSvar;
        return { value: svarId, label: tekst };
    });

    const onChange = (selectedId) => {
        context.onChange(definisjon, { value: [selectedId], error: false });
    };

    const selectedOption = () => {
        const answer = context.getValue(definisjon);
        const selectedAnswer = muligeSvar.find((muligSvar) => answer.includes(muligSvar.svarId));
        return selectedAnswer && selectedAnswer.svarId;
    };

    return (
        <div className="radioknobs">
            {isDisabled ? (
                <div>
                    <h2 className="skjema-input-question">{getQuestionText()}</h2>
                    <span>{getPreselected(question).tekst}</span>
                </div>
            ) : (
                <RadioButtons
                    onChange={onChange}
                    options={options}
                    selectedOption={selectedOption()}
                    horizontal={options.length < 3}
                    label={getQuestionText()}
                    hasError={hasError}
                    required
                    errorMessage={hasInvalidValue ? instruks ?? 'Velg ett alternativ' : ''}
                />
            )}
            {reminder && (
                <div className="skjema-input-reminder">
                    <div className="ikon-utropstegn-36 exclamationmark" />
                    {reminder}
                </div>
            )}
        </div>
    );
}

RadioQuestionType.propTypes = {
    question: shape(SkjemaSporsmal).isRequired,
    context: object,
};

export default connect(React.memo(RadioQuestionType));
